import React, { useContext, useMemo } from "react";
import ViewIcon from "@material-ui/icons/InputOutlined";
import EditIcon from "@material-ui/icons/EditOutlined";
import { Region } from "../../../data/listing/regions/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { Action } from "material-table";
import { useHistory } from "react-router-dom";
import { useViewRegion } from "./DisplayRegion";
import { useRegionDelete } from "../../../data/listing/regions/hooks/useRegionDelete";
import { getRegionsEditLocation } from "./Locations";
import { RegType } from "../../../data/models";
import { AccessRights } from "../../../core/navigation/types";

export const useRegionsActions = (userAccessRights: AccessRights) => {
  const { getString } = useContext(LocalizationContext);
  const onShowRegion = useViewRegion();
  const onEditRegion = useEditRegionsAction();

  return useMemo(() => {
    const result: Action<Region>[] = [
      {
        icon: () => <ViewIcon />,
        tooltip: getString("tableShow"),
        onClick: (event, rowData) => onShowRegion(rowData as Region),
      },
      {
        icon: () => <EditIcon />,
        tooltip: getString("tableEdit"),
        onClick: (event, rowData) => onEditRegion(rowData as Region),
        hidden: userAccessRights===AccessRights.ReadOnly
      },
    ];

    return result;
  }, [onShowRegion, onEditRegion, getString]);
};

export const useDeleteRegionAction = (type?: RegType) => {
  const [, deleteRegion] = useRegionDelete(type);
  return React.useCallback(
    async (region: Region) => {
      if (region.regId) {
        await deleteRegion(region.regId);
      }
    },
    [deleteRegion]
  );
};

export const useEditRegionsAction = () => {
  const history = useHistory();
  return React.useCallback(
    (region: Region) =>
      history.push(getRegionsEditLocation(region.regId)),
    [history]
  );
};
